﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederIofDto from '../Models/VeilederIofDto';

const egenInntekt = 'a1-egenInntekt';
const ektefelleSamboer = 'a2-ektefelleSamboer';
const foreldre = 'a3-foreldre';
const formue = 'a4-formue';
const trygd = 'a5-trygd';

const aValg: RadioButtonValgModel<VeilederIofDto>[] = [
    {
        id: 'a1',
        value: egenInntekt,
        tekst: 'valgEgenInntekt',
    },
    {
        id: 'a2',
        value: ektefelleSamboer,
        tekst: 'valgEktefelleSamboer',
    },
    {
        id: 'a3',
        value: foreldre,
        tekst: 'valgForeldre',
    },
    {
        id: 'a4',
        value: formue,
        tekst: 'valgFormue',
    },
    {
        id: 'a5',
        value: trygd,
        tekst: 'valgTrygd',
    },
];

export default {
    a1_egenInntekt: egenInntekt,
    a2_ektefelleSamboer: ektefelleSamboer,
    a3_foreldre: foreldre,
    a4_formue: formue,
    a5_trygd: trygd,
    aValg,
};
